<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">


                <div class="row">
                  <div class="col-md-9">
                    <h2>Dr. Xenia Coca – Medic rezident psihiatru la "Institutul de Psihiatrie Socola Iasi "</h2>
                     <h2>Co-fondator Clinica Pozitiv Medical</h2>
                    <div class="other-option md-none mt-40">
                      <a href="/#appointment" class="btn style2">
                        Solicită o programare
                      </a>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="team-card style3">
                      <div class="team-img"> <img src="../../../assets/images/team/member-2.jpg"
                          alt="Dr. Xenia Cocea – Psihiatrie" /></div>
                    </div>
                  </div>
                </div>

                <p>
                  Sunt <strong>Dr. Xenia Cocea</strong>
                </p>

                <h3>Educație și formare profesională</h3>

                <h3>Experiență profesională</h3>

                  <ul class="content-feature-list style5 list-style">
                  <li>
                    <i class="ri-check-double-line"></i>
                    Medic rezident psihiatru la "Institutul de Psihiatrie Socola Iasi "
                  </li> 
                </ul>
              </div>
            </div>



          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "PsihiatriePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>